import React, { useState } from "react";
import { eaParams, useEa } from "@/components/energy-analytics/analytics/EaContext";
import { DeltaCell, EaBudgetTable } from "@/components/energy-analytics/analytics/EaBudgetTable";
import { useEaData } from "@/components/energy-analytics/analytics/useEaData";
import { EaPointPicker, useSelectedCodes } from "@/components/energy-analytics/analytics/EaControls";
import { EaEmptyState, EaKpiCard, EaNote, EaPageHeader, EaBudgetBar } from "@/components/energy-analytics/analytics/EaUi";
import { EaDynForecast } from "@/components/energy-analytics/analytics/EaDynForecast";
import { COLORS, fmtEur } from "@/components/energy-analytics/analytics/eaFormat";

const LABEL = { POWER: "Power", GAS: "Gas", ALL: "Totale portfolio" };

export default function EaBudget() {
  const codes = useSelectedCodes();
  const [v, setV] = useState(0);
  const { filters } = useEa();
  const { data: d, loading, error } = useEaData("/ea/overview/budget", { codes, v: v || undefined });
  const header = <EaPageHeader title="Forecast vs Budget" subtitle={`Budget annuali (modificabili) e Forecast, confrontati con la spesa fatturata finora${d?.year ? ` · anno ${d.year}` : ""}.`} right={<EaPointPicker />} />;
  if (loading && !d) return <div className="space-y-6">{header}<div className="text-sm text-slate-400" data-testid="ea-loading">Caricamento…</div></div>;
  if (error) return <div className="space-y-6">{header}<EaEmptyState title="Dati non disponibili" text={error} testid="ea-budget-error" /></div>;
  if (!d.has_data) return <div className="space-y-6">{header}<EaEmptyState title="Nessun dato per l'anno selezionato" testid="ea-budget-empty" /></div>;
  return (
    <div className="space-y-6" data-testid="ea-budget-page">
      {header}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {["ALL", "POWER", "GAS"].filter((k) => d.totals[k]).map((k) => {
          const t = d.totals[k];
          return (
            <EaKpiCard band key={k} label={LABEL[k]} value={fmtEur(t.forecast)} testid={`ea-budget-total-${k.toLowerCase()}`}
              accent={k === "POWER" ? COLORS.power : k === "GAS" ? COLORS.gas : COLORS.total}
              sub={<>Forecast annuale · Budget {fmtEur(t.budget)} · <DeltaCell v={t.delta} pct={t.delta_pct} /><br />Spesa fatturata YTD (parziale): {fmtEur(t.spend_ytd)}</>}>
              <EaBudgetBar spent={t.spend_ytd} budget={t.budget} testid={`ea-budget-bar-${k.toLowerCase()}`} />
            </EaKpiCard>
          );
        })}
      </div>
      <EaBudgetTable d={d} params={eaParams(filters)} codes={codes} onSaved={() => setV((x) => x + 1)} />
      <EaDynForecast reload={v} codes={codes} onBudgetChanged={() => setV((x) => x + 1)} />
      <EaNote testid="ea-budget-note">Δ positivo (rosso) = Forecast sopra Budget. La spesa fatturata YTD comprende solo le fatture ricevute e non rappresenta il valore annuale.</EaNote>
    </div>
  );
}
